import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const { carbon, blue } = colorsPalettes;

export const Wrapper = styled(Flex)<{ isCollapsed: boolean }>`
    overflow: hidden;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    width: ${({ isCollapsed }) => (isCollapsed ? "32px" : "100%")};
    padding: ${({ isCollapsed }) => (isCollapsed ? "7px" : "7px 11px")};
    margin-top: 10px;
    margin-left: ${({ isCollapsed }) => (isCollapsed ? -4 : 0)}px;

    border-radius: 4px;
    border: 1px solid ${carbon[50]};

    cursor: pointer;

    transition:
        width 200ms ease-in-out,
        padding 200ms ease-in-out,
        margin-left 200ms ease-in-out;

    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "250ms" : "0")};
`;

export const Text = styled.span<{ isCollapsed: boolean }>`
    ${setFontVariant("primaryItem", carbon[300])};
    opacity: ${({ isCollapsed }) => (isCollapsed ? 0 : 1)};
    transition: opacity 200ms ease-in-out;
    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "200ms" : "0")};
    text-wrap: nowrap;
`;

export const ShortCutWrapper = styled.div<{ isCollapsed: boolean }>`
    text-align: center;
    padding: 0 6px;

    ${setFontVariant("sectionTitle", carbon[400])};
    font-weight: 700;

    border-radius: 8px;
    background-color: ${blue[50]};
    margin-left: auto;
    text-transform: uppercase;

    opacity: ${({ isCollapsed }) => (isCollapsed ? 0 : 1)};
    transition: opacity 200ms ease-in-out;
    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "200ms" : "0")};
`;
